import { render, staticRenderFns } from "./DatosPartidaYObjetivo.vue?vue&type=template&id=005c2ac4&scoped=true"
import script from "./DatosPartidaYObjetivo.vue?vue&type=script&lang=js"
export * from "./DatosPartidaYObjetivo.vue?vue&type=script&lang=js"
import style0 from "./DatosPartidaYObjetivo.vue?vue&type=style&index=0&id=005c2ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c2ac4",
  null
  
)

export default component.exports